import { useEffect, useState } from 'react';

import { sortItemsByProperty } from '@/src/ContactsModule/utils/sortItemsByProperty';

export const useSortedItems = (selectedItems: string[], itemList: string[]): string[] => {
  const [sortedItems, setSortedItems] = useState<string[]>([]);

  useEffect(() => {
    const selectedSorted = sortItemsByProperty(selectedItems || [], 0);
    const unselectedSorted = sortItemsByProperty(
      itemList.filter((item) => !selectedItems.includes(item)),
      0
    );
    const sorted = [...selectedSorted, ...unselectedSorted];

    setSortedItems(sorted);
  }, [selectedItems, itemList]);

  return sortedItems;
};
